import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme
} from '@mui/material';
import { Logo } from '../../Logo';
import { WorkspacesMenu } from '../WorkspacesMenu/WorkspacesMenu';
import { MainMenuItems } from '../../../../../common/components/MainMenuItems/MainMenuItems';
import { HelpOutlineRounded } from '@mui/icons-material';
import Userbox from '../Userbox/Userbox';
import AccesibilityButtons from '../AccesibilityButtons';
import { MenuToggleContext } from '../../../contexts/MenuToggleContext';

export const InnerMenu = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { closeMenu } = useContext(MenuToggleContext);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100%"
    >
      <Box>
        <Logo />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: theme.spacing(4.55, 0.9, 0, 0.9)
          }}
        >
          <WorkspacesMenu />
          <MainMenuItems />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <ListItemButton
          LinkComponent={'a'}
          href="mailto:info@guud.tv"
          sx={{
            cursor: 'hand',
            pl: 2,
            '&:hover': {
              backgroundColor: 'transparent'
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 34 }}>
            <HelpOutlineRounded sx={{ width: 22 }} />
          </ListItemIcon>
          <ListItemText primary={t('Help & support')} />
        </ListItemButton>
        <Box display="flex" alignItems="center" sx={{ cursor: 'hand' }}>
          <Userbox handleCloseMenu={closeMenu} />
          <AccesibilityButtons />
        </Box>
      </Box>
    </Box>
  );
};
